var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "homeworkPage" }, [
    _vm.testPaper
      ? _c(
          "div",
          { staticClass: "testPaperBox" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.testPaper.testName))]),
            _vm._v(" "),
            _vm.testPaper.totalScore
              ? _c("h3", { staticClass: "score" }, [
                  _vm._v(_vm._s(`共得分：${_vm.testPaper.totalScore}分`)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaper.singleChoiceQuestionNum
              ? _c("div", { staticClass: "singleQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `单选题（共 ${_vm.testPaper.singleChoiceQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "singleQuestionsBox" },
                    _vm._l(
                      _vm.testPaper.singleChoiceQuestions,
                      function (single, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "questions" },
                          [
                            single.checkStatus == "正确"
                              ? _c("i", { staticClass: "el-icon-check" })
                              : _vm._e(),
                            _vm._v(" "),
                            single.checkStatus == "错误"
                              ? _c("i", { staticClass: "el-icon-close" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "questionsTitle" }, [
                                _c("span", [_vm._v(_vm._s(`${index + 1}.`))]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "title",
                                  domProps: {
                                    innerHTML: _vm._s(` ${single.title}`),
                                  },
                                }),
                                _vm._v(" "),
                                single.getQuestionScore
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          `（得分：${single.getQuestionScore}分）`
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "singleOption" },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: single.stuOptionId,
                                        callback: function ($$v) {
                                          _vm.$set(single, "stuOptionId", $$v)
                                        },
                                        expression: "single.stuOptionId",
                                      },
                                    },
                                    _vm._l(
                                      single.options,
                                      function (option, optionIndex) {
                                        return _c(
                                          "el-radio",
                                          {
                                            key: optionIndex,
                                            class: option.isSelect
                                              ? "colorCheck"
                                              : "",
                                            attrs: { label: option.id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.optionsMap[optionIndex]
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  `${option.option}`
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              single.checkStatus == "错误"
                                ? _c(
                                    "div",
                                    _vm._l(
                                      single.options,
                                      function (option, optionIndex) {
                                        return _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  option.id == single.optionId,
                                                expression:
                                                  "option.id == single.optionId",
                                              },
                                            ],
                                            key: optionIndex,
                                            staticClass: "successAnswer",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                `正确答案：${_vm.optionsMap[optionIndex]}`
                                              )
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              single.description && single.checkStatus != "未做"
                                ? _c("div", { staticClass: "analysis" }, [
                                    _vm._v(
                                      _vm._s(`【解析】：${single.description}`)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaper.multipleChoiceQuestionNum
              ? _c("div", { staticClass: "multipleQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `多选题（共 ${_vm.testPaper.multipleChoiceQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "multipleQuestionsBox" },
                    _vm._l(
                      _vm.testPaper.multipleChoiceQuestions,
                      function (multiple, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "questions" },
                          [
                            multiple.checkStatus == "正确"
                              ? _c("i", { staticClass: "el-icon-check" })
                              : _vm._e(),
                            _vm._v(" "),
                            multiple.checkStatus == "错误"
                              ? _c("i", { staticClass: "el-icon-close" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "questionsTitle" }, [
                                _c("span", [_vm._v(_vm._s(`${index + 1}.`))]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(`${multiple.title}`),
                                  },
                                }),
                                _vm._v(" "),
                                multiple.getQuestionScore
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          `（得分：${multiple.getQuestionScore}分）`
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "multipleOption" },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: multiple.stuOptionIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            multiple,
                                            "stuOptionIds",
                                            $$v
                                          )
                                        },
                                        expression: "multiple.stuOptionIds",
                                      },
                                    },
                                    _vm._l(
                                      multiple.options,
                                      function (option, optionIndex) {
                                        return _c(
                                          "el-checkbox",
                                          {
                                            key: optionIndex,
                                            class: option.isSelect
                                              ? "colorCheck"
                                              : "",
                                            attrs: { label: option.id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.optionsMap[optionIndex]
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  `${option.option}`
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              multiple.checkStatus == "错误"
                                ? _c("span", { staticClass: "successAnswer" }, [
                                    _vm._v(
                                      _vm._s(
                                        `正确答案：${multiple.succeedOption.join(
                                          " "
                                        )}`
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              multiple.description &&
                              multiple.checkStatus != "未做"
                                ? _c("div", { staticClass: "analysis" }, [
                                    _vm._v(
                                      _vm._s(
                                        `【解析】：${multiple.description}`
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaper.gapFillingQuestionNum
              ? _c("div", { staticClass: "gapFillingQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `填空题（共 ${_vm.testPaper.gapFillingQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "gapFillingQuestionsBox" },
                    _vm._l(
                      _vm.testPaper.gapFillingQuestions,
                      function (gapFilling, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "questions" },
                          [
                            gapFilling.checkStatus == "正确"
                              ? _c("i", { staticClass: "el-icon-check" })
                              : _vm._e(),
                            _vm._v(" "),
                            gapFilling.checkStatus == "错误"
                              ? _c("i", { staticClass: "el-icon-close" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "questionsTitle" }, [
                                _c("span", [_vm._v(_vm._s(`${index + 1}.`))]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(`${gapFilling.title}`),
                                  },
                                }),
                                _vm._v(" "),
                                gapFilling.getQuestionScore
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          `（得分：${gapFilling.getQuestionScore}分）`
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "gapFillingOption" },
                                _vm._l(
                                  gapFilling.stuGapFilling,
                                  function (option, gapFillingIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key: gapFillingIndex,
                                        staticClass: "gapFillingOptionBox",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              `填空${gapFillingIndex + 1}：`
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: {
                                            disabled: _vm.disabled,
                                            placeholder: "请填写",
                                          },
                                          model: {
                                            value:
                                              gapFilling.stuGapFilling[
                                                gapFillingIndex
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                gapFilling.stuGapFilling,
                                                gapFillingIndex,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "gapFilling.stuGapFilling[gapFillingIndex]",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              gapFilling.checkStatus == "错误"
                                ? _c(
                                    "div",
                                    { staticClass: "judgeSuccessAnswer" },
                                    [
                                      _c("span", [_vm._v("正确答案：")]),
                                      _vm._v(" "),
                                      _vm._l(
                                        gapFilling.gapFilling,
                                        function (suitem, suIndex) {
                                          return _c("span", { key: suIndex }, [
                                            _vm._v(
                                              _vm._s(
                                                `填空${suIndex + 1}: ${
                                                  suitem[0]
                                                }`
                                              )
                                            ),
                                          ])
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              gapFilling.description &&
                              gapFilling.checkStatus != "未做"
                                ? _c("div", { staticClass: "analysis" }, [
                                    _vm._v(
                                      _vm._s(
                                        `【解析】：${gapFilling.description}`
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaper.judgeQuestionNum
              ? _c("div", { staticClass: "judgeQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `判断题（共 ${_vm.testPaper.judgeQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "judgeQuestionsBox" },
                    _vm._l(
                      _vm.testPaper.judgeQuestions,
                      function (judge, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "questions" },
                          [
                            judge.checkStatus == "正确"
                              ? _c("i", { staticClass: "el-icon-check" })
                              : _vm._e(),
                            _vm._v(" "),
                            judge.checkStatus == "错误"
                              ? _c("i", { staticClass: "el-icon-close" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "questionsTitle" }, [
                                _c("span", [_vm._v(_vm._s(`${index + 1}.`))]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(`${judge.title}`),
                                  },
                                }),
                                _vm._v(" "),
                                judge.getQuestionScore
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          `（得分：${judge.getQuestionScore}分）`
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "judgeOption" },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: judge.stuAnswer,
                                        callback: function ($$v) {
                                          _vm.$set(judge, "stuAnswer", $$v)
                                        },
                                        expression: "judge.stuAnswer",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "正确" } },
                                        [_vm._v("正确")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "错误" } },
                                        [_vm._v("错误")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              judge.checkStatus == "错误"
                                ? _c("span", { staticClass: "successAnswer" }, [
                                    _vm._v("正确答案："),
                                    _c("i", {
                                      class:
                                        judge.answer == "正确"
                                          ? "el-icon-circle-check"
                                          : "el-icon-circle-close",
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              judge.description && judge.checkStatus != "未做"
                                ? _c("div", { staticClass: "analysis" }, [
                                    _vm._v(
                                      _vm._s(`【解析】：${judge.description}`)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaper.comprehensiveQuestionNum
              ? _c("div", { staticClass: "comprehensiveQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `问答题（共 ${_vm.testPaper.comprehensiveQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "comprehensiveQuestionsBox" },
                    _vm._l(
                      _vm.testPaper.comprehensiveQuestions,
                      function (comprehensive, index) {
                        return _c("div", { key: index }, [
                          _c("span", {
                            staticClass: "questionsBox",
                            domProps: {
                              innerHTML: _vm._s(
                                `${index + 1}. ${comprehensive.title}`
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "comprehensiveOption" },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: { minRows: 10 },
                                  resize: "none",
                                  disabled: _vm.disabled,
                                },
                                model: {
                                  value: comprehensive.stuAnswer,
                                  callback: function ($$v) {
                                    _vm.$set(comprehensive, "stuAnswer", $$v)
                                  },
                                  expression: "comprehensive.stuAnswer",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaper.comprehensiveQuestionNum ||
            _vm.testPaper.gapFillingQuestionNum ||
            _vm.testPaper.multipleChoiceQuestionNum ||
            _vm.testPaper.singleChoiceQuestionNum
              ? _c(
                  "el-row",
                  {
                    staticStyle: { margin: "25px 0" },
                    attrs: { type: "flex", justify: "center" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.disabled },
                        on: { click: _vm.submit },
                      },
                      [_vm._v("提交习题")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/resource/exercisesResource.vue?vue&type=template&id=55abd118&
// module id = null
// module chunks = 